import React from 'react';
import { useDropzone } from 'react-dropzone';

export function FileSelector(props) {
  const { dragActiveText, dropZoneText, onSelectedFiles, disabled, children } = props;

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop: onSelectedFiles,
    disabled
  });

  return (
    <div {...getRootProps({ className: `file-selector${disabled === true ? ' disabled' : ''}` })}>
      <input {...getInputProps()} />
      {isDragActive ? dragActiveText : dropZoneText}
      {children}
    </div>
  );
}

export default FileSelector;
